import { Injectable } from '@angular/core';
import { getRandomNumber, isMobileView } from '@app/utils';
import { MatDialog } from '@angular/material/dialog';
import { ChartsStoreService } from '@app/core/features/charts-store/charts-store.service';
import { FreeCartModel, ProductCart } from '@app/core/features/charts-store';
import { Globals } from '@app/shared/models';
import { ADD_TO_CART } from '@app/constants/add-to-cart';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class ShoppingCartService {
  constructor(
    private chartStoreService: ChartsStoreService,
    private cookieService: CookieService,
    public dialog: MatDialog,
    private globals: Globals
  ) { }

  showDialog(userId: string, component: any, voucherCode: string) {
    const latestAdded = JSON.parse(this.cookieService.get(ADD_TO_CART.LATEST_PRODUCT_ADDED));
    const userCookies = latestAdded.find(x => x.userId === userId);

    this.dialog.open(component, {
      maxWidth: isMobileView() ? '95vw' : '80vw',
      data: { userCookies, voucherCode }
    });
    this.globals.isDisplayProgressSpinner = false;
  }

  removeFree(sku: string, current: ProductCart, userId: string) {
    if (current) {
      this.removeItem(current.quantity === 1, userId, sku, current.quantity - 1, true);
    }
  }

  removeNormal(sku: string, userId: string) {
    // If it exist on cookies (12 months premium), just set quantity 1
    this.removeItem(
      !this.chartStoreService.getFreeCart().find(x => x.sku === sku), userId, sku, 1
    );
  }

  private removeItem(
    isDelete: boolean, userId: string, sku: string, quantity: number, isFree: boolean = false
  ) {
    this.handleRemoveCallback(userId, sku, isFree);
  }

  private handleRemoveCallback(userId: string, sku: string, isFree: boolean) {
    // Remove latest added product out of cookies
    this.chartStoreService.removeAddedProduct(userId, sku);

    if (isFree) {
      // Remove free product in cookies
      this.chartStoreService.removeFreeCart(sku);
    }

    this.globals.isDisplayProgressSpinner = false;

    // Trigger the checking item of the cart run to update the new data
    this.chartStoreService.checkEditListItemOnCart.next(getRandomNumber());

    // Update add to voucher redeem list
    const latestAdded = JSON.parse(this.cookieService.get(ADD_TO_CART.LATEST_PRODUCT_ADDED));
    this.chartStoreService.numberOfChartInVoucherRedeem.next(latestAdded.find(x => x.userId === userId).product.length);
  }

  addItem(userId: string, sku: string, component: any, centerPoint: number[], voucherCode: string) {
    // Set to cookie the latest product added to cart
    this.chartStoreService.setAddedProduct(userId, sku, centerPoint);
    const latestAdded = JSON.parse(this.cookieService.get(ADD_TO_CART.LATEST_PRODUCT_ADDED));
    this.chartStoreService.numberOfChartInVoucherRedeem.next(latestAdded.find(x => x.userId === userId).product.length);

    // Open add to cart dialog right after added
    this.showDialog(userId, component, voucherCode);
  }

  createFreeCartModel = (
    type: number, sku: string, voucherCode: string
  ): FreeCartModel => {
    return {
      type, sku, voucherCode
    };
  }
}
